"use client"

import * as React from "react"
import { Calculator as CalcIcon, Delete } from "lucide-react"

interface CalculatorAppProps {
  calcFormula?: string
  calcDisplay: string
  handleCalcPress: (val: string) => void
}

export function CalculatorApp({ calcFormula, calcDisplay, handleCalcPress }: CalculatorAppProps) {
  const buttons: Array<{ label: string; val: string; type: "num" | "op" | "fn"; colSpan?: number }> = [
    { label: "AC", val: "AC", type: "fn" },
    { label: "±", val: "±", type: "fn" },
    { label: "%", val: "%", type: "fn" },
    { label: "÷", val: "/", type: "op" },

    { label: "7", val: "7", type: "num" },
    { label: "8", val: "8", type: "num" },
    { label: "9", val: "9", type: "num" },
    { label: "×", val: "*", type: "op" },

    { label: "4", val: "4", type: "num" },
    { label: "5", val: "5", type: "num" },
    { label: "6", val: "6", type: "num" },
    { label: "−", val: "-", type: "op" },

    { label: "1", val: "1", type: "num" },
    { label: "2", val: "2", type: "num" },
    { label: "3", val: "3", type: "num" },
    { label: "+", val: "+", type: "op" },

    { label: "0", val: "0", type: "num", colSpan: 2 },
    { label: ",", val: ".", type: "num" },
    { label: "=", val: "=", type: "op" },
  ]

  return (
    <div className="flex-1 w-full overflow-hidden bg-zinc-50 dark:bg-zinc-950 p-6 flex flex-col items-center justify-center font-sans">
      <div className="max-w-[340px] w-full bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-3xl p-5 shadow-2xl space-y-4 text-zinc-900 dark:text-white">
        <div className="flex items-center justify-between px-1">
          <div className="flex items-center gap-2">
            <div className="size-6 rounded-lg bg-blue-500/10 dark:bg-blue-500/20 text-[#004EB1] dark:text-blue-400 flex items-center justify-center">
              <CalcIcon className="size-3.5" />
            </div>
            <h3 className="font-bold text-xs uppercase tracking-wider text-zinc-500 dark:text-zinc-400">
              Calculadora
            </h3>
          </div>
          <button
            type="button"
            onClick={() => handleCalcPress("del")}
            title="Apagar dígito (Backspace)"
            className="p-1.5 text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors cursor-pointer active:scale-90"
          >
            <Delete className="size-4" />
          </button>
        </div>

        <div className="p-4 bg-zinc-100 dark:bg-zinc-950 rounded-2xl text-right space-y-1 border border-zinc-200/50 dark:border-zinc-800/60 shadow-inner">
          <div className="text-xs text-zinc-450 dark:text-zinc-500 font-mono h-4 truncate select-none">
            {calcFormula || "\u00a0"}
          </div>
          <div className="text-3xl font-bold font-mono truncate leading-tight tracking-tight select-text text-zinc-900 dark:text-white">
            {calcDisplay}
          </div>
        </div>

        <div className="grid grid-cols-4 gap-2.5 select-none">
          {buttons.map((btn) => {
            const isOperator = btn.type === "op"
            const isAction = btn.type === "fn"

            return (
              <button
                key={btn.label}
                type="button"
                onClick={() => handleCalcPress(btn.val)}
                className={`h-12 rounded-2xl font-bold text-base transition-all active:scale-95 cursor-pointer shadow-xs ${btn.colSpan === 2 ? "col-span-2 text-left pl-6" : "flex items-center justify-center"
                  } ${isOperator
                    ? "bg-[#004EB1] hover:bg-[#003d8d] text-white"
                    : isAction
                      ? "bg-zinc-200/80 dark:bg-zinc-800 text-zinc-750 dark:text-zinc-300 hover:bg-zinc-300 dark:hover:bg-zinc-750"
                      : "bg-zinc-100 dark:bg-zinc-800/50 text-zinc-850 dark:text-zinc-100 hover:bg-zinc-200 dark:hover:bg-zinc-700 border border-zinc-200/40 dark:border-zinc-800/40"
                  }`}
              >
                {btn.label}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
